<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        data: any;
    }>();

    const key = () => {
        return JSON.stringify(props.data);
        // return `${props.data.id}-${props.data.updated_at}`; // Less memory usage but not sure we can rely on updated_at
    };
</script>

<template>
    <div
        :key="key()"
        :class="cn('flex items-center gap-1', props.class)"
        data-action
    >
        <slot />
    </div>
</template>
